import { createGlobalStyle } from "styled-components";

const GlobalStyle: any = createGlobalStyle`
.ant-form-vertical .ant-form-item-label {
  padding-bottom: 0px !important;
  bottom: -12px;
  left:${({ dir }: any) => (dir == "rtl" ? "-15px" : "initial")} ;
  right:${({ dir }: any) => (dir == "rtl" ? "initial" : "-15px")} ;
  padding-left:${({ dir }: any) => (dir == "rtl" ? "2px" : "5px")} ;
  padding-right:${({ dir }: any) => (dir == "rtl" ? "5px" : "2px")} ;
}
.ant-input-number-group-rtl .ant-input-number-group-addon:last-child{
  border-left: 1px;
  border-right: 1px solid #dddddd;
  border-radius: 5px 0 0 5px;

}
${({ classes }: any) => classes};

`;

export default GlobalStyle;
